import { BaseAdvancedOperation } from './base-advanced-operation';
import { IMoveArticlesOperation } from './i-move-articles-operation';
import { UndoAttachArticlesOperation } from './undo-attach-articles-operation';
import { Dictionary } from 'typescript-collections';
import { Vector3 } from 'three';
import { InsertArticleUtils } from '@project/components/article/util/insert-article-utils';

export class UndoInsertArticlesByLocationOperation extends BaseAdvancedOperation implements IMoveArticlesOperation {
  private _attachArticlesOperation: UndoAttachArticlesOperation;
  private _moveArticlesMap: Dictionary<string, Vector3>;

  constructor(
    attachOperation: UndoAttachArticlesOperation,
    moveArticlesMap: Dictionary<string, Vector3>,
    private insertArticleUtils: InsertArticleUtils
  ) {
    super();
    this._attachArticlesOperation = attachOperation;
    this._moveArticlesMap = moveArticlesMap;
  }

  public getQualifiedClassName(): string {
    return 'UndoInsertArticlesByLocationOperation';
  }

  public getMoveArticlesMap(): Dictionary<string, Vector3> {
    return this._moveArticlesMap;
  }

  public isArticlesOrderChanged(): boolean {
    return false;
  }

  public isDistanceBetweenArticlesChanged(): boolean {
    return true;
  }

  public async performUndo(): Promise<void> {
    await super.performUndo();
    if (this._attachArticlesOperation) {
      await this._attachArticlesOperation.performUndo();
    }
    this.insertArticleUtils.moveArticlesByMap(this._moveArticlesMap, true);
  }

  public async performRedo(): Promise<void> {
    this.insertArticleUtils.moveArticlesByMap(this._moveArticlesMap, false);
    if (this._attachArticlesOperation) {
      await this._attachArticlesOperation.performRedo();
    }
    await super.performRedo();
  }
}
